function RecommTable(props: any) {
    //console.log("<RecommTable debug of vars")
    //console.log(Object.entries(props.recommendations))
    return (
        <table>
            <tbody>
            {Object.entries(props.recommendations).map((recomm: any) =>
                <tr key={recomm[1].rodina_kod}><td style={{textAlign:'left'}}>{recomm[1].rodina_kod}&nbsp;</td><td className={'recommT-' + recomm[1].pouziti_id} width="100%">&nbsp;</td></tr>)}
            </tbody>
        </table>
    )
}
export default RecommTable